module.exports = __webpack_public_path__ + "static/img/2.c1f71b48.png";